document.addEventListener('DOMContentLoaded', function() {
  // Função para aplicar máscara no telefone
  function applyPhoneMask(input) {
    let value = input.value;
    
    // Se o usuário removeu tudo, permite que fique vazio
    if (value === '') {
      return;
    }
    
    // Se o usuário removeu o +, adiciona de volta
    if (!value.startsWith('+')) {
      value = '+' + value;
    }
    
    // Extrai apenas os números após o +
    let numbers = value.substring(1).replace(/\D/g, '');
    
    // Se não tem números após o +, mantém apenas o +
    if (numbers === '') {
      input.value = '+';
      return;
    }
    
    // Aplica a máscara conforme o formato (XX) X XXXX - XXXX
    let maskedValue = '+' + numbers.substring(0, 2); // DDI
    
    if (numbers.length > 2) {
      maskedValue += ' (';
      maskedValue += numbers.substring(2, 4); // DDD
      maskedValue += ') ';
    }
    
    if (numbers.length > 4) {
      maskedValue += numbers.substring(4, 9); // Primeira parte do número
    }
    
    if (numbers.length > 9) {
      maskedValue += '-';
      maskedValue += numbers.substring(9, 13); // Segunda parte do número
    }
    
    input.value = maskedValue;
  }
  
  // Função para obter apenas os números do telefone
  function getPhoneNumbers(input) {
    // Remove tudo exceto números, incluindo o +
    return input.value.replace(/\D/g, '');
  }
  
  // Função para verificar se o telefone está completo
  function isPhoneComplete(input) {
    const numbers = getPhoneNumbers(input);
    const value = input.value;
    
    // Verifica se tem o formato completo: +55 (XX) XXXXX-XXXX ou +55 (XX) XXXX-XXXX
    const completePattern = /^\+55\s\(\d{2}\)\s\d{4,5}-\d{4}$/;
    
    // Formato 1: +55 (XX) XXXXX-XXXX (13 dígitos)
    // Formato 2: +55 (XX) XXXX-XXXX (12 dígitos)
    const isValidLength = numbers.length >= 12 && numbers.length <= 13;
    
    return isValidLength && completePattern.test(value);
  }
  
  // Função para validar o telefone
  function validatePhone(input) {
    const numbers = getPhoneNumbers(input);
    const value = input.value;
    
    if (isPhoneComplete(input)) {
      input.setCustomValidity('');
      input.classList.remove('field__input--error');
      input.title = '';
    } else {
      let errorMessage = '';
      
      if (numbers.length < 12) {
        errorMessage = 'Telefone incompleto. Deve ter pelo menos 12 dígitos.';
      } else if (numbers.length > 13) {
        errorMessage = 'Telefone muito longo. Máximo de 13 dígitos.';
      } else if (!value.match(/^\+55\s\(\d{2}\)\s\d{4,5}-\d{4}$/)) {
        errorMessage = 'Formato inválido. Use: +55 (XX) XXXX-XXXX ou +55 (XX) XXXXX-XXXX';
      } else {
        errorMessage = 'Telefone deve estar completo. Exemplo: +55 (11) 11111-1111';
      }
      
      input.setCustomValidity(errorMessage);
      input.classList.add('field__input--error');
      input.title = errorMessage;
    }
  }
  
  // Função para validar o formulário antes do envio
  function validateForm(form) {
    const phoneInput = form.querySelector('input[name="contact[phone]"]');
    const emailInput = form.querySelector('input[name="contact[email]"]');
    
    // Valida o telefone
    validatePhone(phoneInput);
    
    // Verifica se o telefone está válido
    if (!isPhoneComplete(phoneInput)) {
      // Foca no campo de telefone para mostrar o erro
      phoneInput.focus();
      return false;
    }
    
    // Verifica se o email está preenchido
    if (!emailInput.value || !emailInput.checkValidity()) {
      emailInput.focus();
      return false;
    }
    
    return true;
  }
  
  // Aplica a máscara em todos os inputs de telefone do newsletter
  function initPhoneMasks() {
    const phoneInputs = document.querySelectorAll('input[name="contact[phone]"]');
    
    phoneInputs.forEach(function(input) {
      // Define o valor inicial como +55
      input.value = '+55';
      
      // Aplica a máscara no input
      input.addEventListener('input', function() {
        applyPhoneMask(this);
        // Valida em tempo real
        validatePhone(this);
      });
      
      // Aplica a máscara no focus
      input.addEventListener('focus', function() {
        // Se estiver vazio, define como +55
        if (this.value === '') {
          this.value = '+55';
        }
        // Remove classe de erro ao focar
        this.classList.remove('field__input--error');
      });
      
      // Valida no blur
      input.addEventListener('blur', function() {
        validatePhone(this);
      });
      
      // Previne entrada de caracteres não numéricos
      input.addEventListener('keypress', function(e) {
        const char = String.fromCharCode(e.which);
        if (!/\d/.test(char)) {
          e.preventDefault();
        }
      });
      
      // Permite colar números ou telefones formatados
      input.addEventListener('paste', function(e) {
        e.preventDefault();
        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
        
        // Se o texto colado já tem formato de telefone, usa ele
        if (pastedText.includes('+') || pastedText.includes('(') || pastedText.includes(')')) {
          this.value = pastedText;
          applyPhoneMask(this);
        } else {
          // Se são apenas números, adiciona o + e formata
          const numbers = pastedText.replace(/\D/g, '');
          if (numbers.length > 0) {
            this.value = '+' + numbers;
            applyPhoneMask(this);
          }
        }
        
        // Valida após colar
        validatePhone(this);
      });
    });
    
    // Adiciona validação ao formulário
    const forms = document.querySelectorAll('.newsletter-form');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        if (!validateForm(this)) {
          e.preventDefault();
          return false;
        }
      });
    });
  }
  
  // Inicializa as máscaras quando o DOM estiver pronto
  initPhoneMasks();
  
  // Reinicializa as máscaras quando o Shopify recarregar seções
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('input[name="contact[phone]"]')) {
        setTimeout(initPhoneMasks, 100);
      }
    });
  }
});
